import { useCallback, useEffect, useState } from 'react';

function storageKey(userId) {
  const id = userId != null && String(userId).trim() !== '' ? String(userId) : 'anonymous';
  return `aurax_nav_pins_${id}`;
}

function readPins(userId) {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((p) => typeof p === 'string' && p.trim()) : [];
  } catch {
    return [];
  }
}

function writePins(userId, paths) {
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(paths));
  } catch {
    /* ignore quota */
  }
}

/**
 * Pins de navegação lateral — persistidos por usuário em localStorage.
 * Ordem do array = ordem em FAVORITOS (primeiro = topo).
 */
export function useNavPins(userId) {
  const [pinnedPaths, setPinnedPaths] = useState(() => readPins(userId));

  useEffect(() => {
    setPinnedPaths(readPins(userId));
  }, [userId]);

  useEffect(() => {
    const key = storageKey(userId);
    const onStorage = (e) => {
      if (e.key === key) setPinnedPaths(readPins(userId));
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [userId]);

  const isPinned = useCallback(
    (path) => pinnedPaths.includes(path),
    [pinnedPaths],
  );

  const togglePin = useCallback(
    (path) => {
      if (!path) return;
      setPinnedPaths((prev) => {
        let next;
        if (prev.includes(path)) {
          next = prev.filter((p) => p !== path);
        } else {
          next = [path, ...prev.filter((p) => p !== path)];
        }
        writePins(userId, next);
        return next;
      });
    },
    [userId],
  );

  return { pinnedPaths, isPinned, togglePin };
}
